import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import { loginService } from "../../apiServices/services/AuthServices";
import { useNavigate } from "react-router-dom";
import { getCompanyData } from "../../apiServices/services/DocumentsServices";

const LoginPage = () => {
  const [email, setEmail] = useState(
    localStorage.getItem("registeredEmail") ?? ""
  );
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const order = [
    "username",
    "email",
    "provider",
    "password",
    "resetPasswordToken",
    "confirmationToken",
    "confirmed",
    "blocked",
    "role",
    "company",
    "isCompanyDetailsCompleted",
    "isDirectorDetailsCompleted",
    "isTypeOfShareDetailsCompleted",
    "isShareholdingDetailsCompleted",
    "isBankingDetailsCompleted",
    "isFormCompleted",
  ];

  const navigate = useNavigate();

  const naviagteHandler = () => {
    navigate("/signup");
  };

  const getActiveForm = (data) => {
    const keys = Object.keys(data);
    for (let i = keys.length - 1; i >= 5; i--) {
      if (data[keys[i]] === true) {
        return keys[i];
      }
    }
    return null;
  };

  const transformApiResponse = (apiResponse, order) => {
    if (!apiResponse || !apiResponse.user) {
      throw new Error("Invalid API response format.");
    }

    const unwantedFields = [
      "isCompanyIncorporated",
      "isBussinesBankSetup",
      "isBussinessInsuranceCompliant",
      "isFinanceDone",
      "isBusinessConsultationDone",
    ];

    const filteredUser = Object.keys(apiResponse.user).reduce((acc, key) => {
      if (!unwantedFields.includes(key)) {
        acc[key] = apiResponse.user[key];
      }
      return acc;
    }, {});

    const reorderedUser = {};
    order.forEach((key) => {
      if (key in filteredUser) {
        reorderedUser[key] = filteredUser[key];
      }
    });

    Object.keys(filteredUser).forEach((key) => {
      if (!(key in reorderedUser)) {
        reorderedUser[key] = filteredUser[key];
      }
    });

    return {
      jwt: apiResponse.jwt,
      user: reorderedUser,
    };
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    const data = {
      identifier: email,
      password: password,
    };
    loginService(data).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        const riseFormationAddressItem = res.data.user.cartDetails.find(
          (item) => item.name === "RiseFormations Address"
        );
        const transformedResponse = transformApiResponse(res?.data, order);
        localStorage.setItem("token", res?.data?.jwt);
        localStorage.setItem(
          "username",
          res?.data?.user?.firstName + " " + res?.data?.user?.lastName
        );
        localStorage.setItem("useremail", res?.data?.user?.email);
        localStorage.setItem("userId", res?.data?.user?.id);
        const activeForm = getActiveForm(transformedResponse?.user);
        localStorage.setItem("activeForm", activeForm);
        localStorage.setItem(
          "addedFeatures",
          JSON.stringify(res.data.user.cartDetails[0]?.features)
        );
        localStorage.setItem(
          "sensitiveDocumentUploaded",
          JSON.stringify(res.data.user.sensitiveDocumentUploaded)
        );
        getCompanyData(res?.data?.user?.id).then((response) => {
          const isPaymentCompleted = response.company.paymentCompleted;
          if (!isPaymentCompleted) {
            setError("Something went wrong, please try again");
          } else if (riseFormationAddressItem) {
            navigate("/company", { state: { riseFormationAddressItem } });
          } else {
            navigate("/company");
          }
        });
      } else {
        setError("Something went wrong, please try again");
      }
      setLoading(false);
    });
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="100%"
      sx={{
        backgroundColor: "#F6F5F8",
        color: "#2F2D3B",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          maxWidth: "1440px",
          width: "100%",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            maxWidth: "726px",
            width: "100%",
          }}
        >
          <Box
            component="form"
            display="flex"
            flexDirection="column"
            sx={{
              borderRadius: "10px",
              padding: "3.5rem",
              maxWidth: "726px",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "2rem",
                marginBottom: "3rem",
                color: "#0F0049",
              }}
            >
              Sign in to your account
            </Typography>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <Box sx={{ width: "100%", mb: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  mb: 2,
                  fontSize: "1.25rem",

                  color: "#0F0049",
                }}
              >
                Email
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    borderColor: "#d3d3d3",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#d3d3d3",
                  },
                  mb: 2,
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Box>
            <Box sx={{ width: "100%", mb: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  mb: 2,
                  fontSize: "1.25rem",
                  color: "#0F0049",
                }}
              >
                Password
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    borderColor: "#d3d3d3",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#d3d3d3",
                  },
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%", my: 2 }}
            >
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                }
                label="Stay signed in for a week"
              /> */}
              <Link href="/forgot-password" underline="none">
                Forgot your password?
              </Link>
            </Box>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              sx={{
                mt: 2,
                backgroundColor: "#2069F8",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#181e54",
                },
              }}
              onClick={handleSubmit}
            >
              {loading ? "Loading..." : "Continue"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;
